import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 8 12" {...props}>
      <title>{props.title || 'Chevron Left'}</title>
      <g fill="none" stroke="none" strokeWidth="1" fillRule="evenodd">
        <g
          transform="translate(1.000000, 1.000000)"
          stroke="currentColor"
          strokeWidth="2"
        >
          <polyline
            transform="translate(3.500000, 5.507797) rotate(90.000000) translate(-3.500000, -5.507797) "
            points="-1.5 3 3.5155939 8.0155939 8.5 3.0311879"
          />
        </g>
      </g>
    </Icon>
  )
}
